/* MVST Blog — reading progress, table of contents highlighting, gallery thumbnails and copy-link sharing. */
(() => {
  const progress = document.querySelector('[data-mvst-progress]');
  if (progress) {
    document.body.appendChild(progress);
    const fill = progress.firstElementChild;
    let queued = false;
    const paint = () => {
      queued = false;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const ratio = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
      fill.style.transform = `scaleX(${ratio})`;
    };
    const queue = () => {
      if (!queued) {
        queued = true;
        requestAnimationFrame(paint);
      }
    };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    paint();
  }

  const toc = document.querySelector('.mvst-toc');
  if (toc) {
    const links = Array.from(toc.querySelectorAll('a[href^="#"]'));
    const targets = links
      .map((link) => ({ link, el: document.getElementById(decodeURIComponent(link.hash.slice(1))) }))
      .filter((item) => item.el);
    let ticking = false;

    const update = () => {
      ticking = false;
      // Headings count as reached 150px from the top, or just below the theme's sticky header.
      const sticky = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height')) || 0;
      const offset = Math.max(150, sticky + 24);
      let active = null;
      for (const item of targets) {
        if (item.el.getBoundingClientRect().top <= offset) active = item;
      }
      if (!active && targets.length) active = targets[0];
      links.forEach((link) => link.classList.toggle('is-active', active && link === active.link));
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
    update();
  }

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('.mvst-gallery__thumb');
    if (thumb) {
      const gallery = thumb.closest('[data-mvst-gallery]');
      const main = gallery && gallery.querySelector('[data-mvst-gallery-main]');
      if (main) {
        main.src = thumb.dataset.src;
        main.alt = thumb.dataset.alt || '';
        gallery.querySelectorAll('.mvst-gallery__thumb').forEach((item) => {
          item.classList.toggle('is-active', item === thumb);
          item.setAttribute('aria-pressed', item === thumb ? 'true' : 'false');
        });
      }
      return;
    }

    const button = event.target.closest('[data-mvst-copy]');
    if (!button || !navigator.clipboard) return;
    navigator.clipboard.writeText(button.getAttribute('data-mvst-copy')).then(() => {
      button.classList.add('is-copied');
      setTimeout(() => button.classList.remove('is-copied'), 1600);
    });
  });
})();
